module.exports = __webpack_public_path__ + "static/media/web_hi_res_512.79f34d7c.png";